var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C8.3384 0 8.6128 0.2744 8.6128 0.6128V7.3864H15.3872C15.5498 7.3864 15.7058 7.451 15.8208 7.566C15.9358 7.681 16.0004 7.83697 16.0004 7.9996C16.0004 8.16223 15.9358 8.3182 15.8208 8.4332C15.7058 8.54819 15.5498 8.6128 15.3872 8.6128H8.6128V15.3872C8.6128 15.5497 8.54824 15.7056 8.43332 15.8205C8.31839 15.9354 8.16253 16 8 16C7.83748 16 7.68161 15.9354 7.56668 15.8205C7.45176 15.7056 7.3872 15.5497 7.3872 15.3872L7.3864 8.6128H0.6128C0.450275 8.6128 0.294407 8.54824 0.179485 8.43332C0.0645627 8.31839 0 8.16253 0 8C0 7.83748 0.0645627 7.68161 0.179485 7.56668C0.294407 7.45176 0.450275 7.3872 0.6128 7.3872L7.3864 7.3864V0.6128C7.38724 0.450397 7.45219 0.294897 7.5671 0.180134C7.68201 0.0653704 7.8376 0.000630564 8 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon_cross.6d132c0c310631caf11d1021df7ef38f.svg";
export { ForwardRef as ReactComponent };